// extracted by mini-css-extract-plugin
export default {"buttonBlock":"DownloadAsDocumentButton_buttonBlock__LpHAj","buttonGroup":"DownloadAsDocumentButton_buttonGroup__C6ObS"};